import { ApiResponse } from 'apisauce';

import { GatewayResponse } from '~types/gateway';

import UtilFunctions from '~utils/functions';
import { TGetProjectListingAPIParams, TGetProjectListingAPIResponse, TCreateNewProjectAPIParams, TGetProjectDetailsAPIParams, TProjectDetails, TEditProjectDetailsAPIParams, TGetProjectFilterAPIParams, TGetProjectFilterAPIResponse } from '~types/feat/project';
import { IProjectGateway } from './projectBase';
import { TGetPendingProjectListingReduxResponse, TGetProjectChangeHistoryAPIParams } from '~types/feat/setting';

const { API: { getHeaders } } = UtilFunctions;

export default class ProjectGateway extends IProjectGateway {
    async getProjectListing(params: TGetProjectListingAPIParams): GatewayResponse<TGetProjectListingAPIResponse> {
        const { authToken, ...restOfGetProjectListingAPIParams } = params;
        const response: ApiResponse<TGetProjectListingAPIResponse> = await this.api.get('/project/getProjectListing', restOfGetProjectListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async createNewProject(params: TCreateNewProjectAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfCreateNewProjectAPIParams } = params;
        const response: ApiResponse<null> = await this.api.post('/project/createProject', restOfCreateNewProjectAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getProjectDetails(params: TGetProjectDetailsAPIParams): GatewayResponse<TProjectDetails> {
        const { authToken, projectId } = params;
        const response: ApiResponse<TProjectDetails> = await this.api.get('/project/getProjectDetails', { projectId }, getHeaders(authToken));
        return this.process(response);
    }

    async editProjectDetails(params: TEditProjectDetailsAPIParams): GatewayResponse<null> {
        const { authToken, ...body } = params;
        const response: ApiResponse<null> = await this.api.put(
            '/project/editProjectDetails',
            body,
            getHeaders(authToken)
        );
        return this.process(response);
    }

    async getProjectChangeHistoryListing(params: TGetProjectChangeHistoryAPIParams): GatewayResponse<TGetPendingProjectListingReduxResponse> {
        const { authToken, ...restOfGetProjectChangeHistoryAPIParams } = params;
        const response: ApiResponse<TGetPendingProjectListingReduxResponse> = await this.api.get('/project/getProjectChangeHistoryListing', restOfGetProjectChangeHistoryAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getProjectFilters(params: TGetProjectFilterAPIParams): GatewayResponse<TGetProjectFilterAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TGetProjectFilterAPIResponse> = await this.api.get('/project/getProjectFilter', {}, getHeaders(authToken));
        return this.process(response);
    }

}
